// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    overflow: visible !important;
}

* {
    box-sizing: border-box;
}

.uploadfile {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 20px 20px 22px 20px;
    font-family: "Segoe UI";
    transition: background-color 0.3s;
}

    .uploadfile:hover {
        background-color: #FFFCFF;
    }

.uploadfile--dragging {
    background-color: #FFFCFF;
}

    .uploadfile--dragging .uploadfile__drag-file-area {
        border-color: #000;
        background-color: #b0b0b0;
    }

.uploadfile--added .uploadfile__drag-file-area {
    display: none;
}

.uploadfile--added .uploadfile__fileName {
    display: block;
}

.uploadfile__title {
    padding-bottom: 8px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
}

.uploadfile__drag-file-area {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 96px;
    background-color: #D0D0D0;
    margin-bottom: 8px;
    text-align: center;
    border: 1px dashed #808080;
    font-size: 9px;
    font-weight: 400;
    line-height: 16px;
    color: #808080;
    transition: border-color 0.3s, background-color 0.3s;
}

.uploadfile__info {
    max-width: 95px;
}

.uploadfile__fileName {
    display: none;
    width: 100%;
    margin-bottom: 9px;
    padding-top: 4px;
    padding-bottom: 4px;
    text-align: center;
    color: #000;
    border: 1px solid #808080;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.uploadfile__fileName--success {
    background-color: #88CC99;
}

.uploadfile__fileName--error {
    background-color: #EE6655;
}

.uploadfile__footer {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.uploadfile__btn {
    height: 18px;
    padding-right: 8px;
    padding-left: 8px;
    font-weight: 400;
    font-size: 9px;
    line-height: 16px;
    cursor: pointer;
    border: 1px solid #808080;
    background-color: transparent;
}

.uploadfile__btn--hidden {
    display: none;
}

.uploadfile__btn:last-child {
    margin-left: auto;
}

.uploadfile__upload-input {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/controls/uploadfile/uploadfile.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,4BAA4B;IAC5B,uBAAuB;IACvB,iCAAiC;AACrC;;IAEI;QACI,yBAAyB;IAC7B;;AAEJ;IACI,yBAAyB;AAC7B;;IAEI;QACI,kBAAkB;QAClB,yBAAyB;IAC7B;;AAEJ;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,oDAAoD;AACxD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[":host {\r\n    overflow: visible !important;\r\n}\r\n\r\n* {\r\n    box-sizing: border-box;\r\n}\r\n\r\n.uploadfile {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    margin: 0;\r\n    padding: 20px 20px 22px 20px;\r\n    font-family: \"Segoe UI\";\r\n    transition: background-color 0.3s;\r\n}\r\n\r\n    .uploadfile:hover {\r\n        background-color: #FFFCFF;\r\n    }\r\n\r\n.uploadfile--dragging {\r\n    background-color: #FFFCFF;\r\n}\r\n\r\n    .uploadfile--dragging .uploadfile__drag-file-area {\r\n        border-color: #000;\r\n        background-color: #b0b0b0;\r\n    }\r\n\r\n.uploadfile--added .uploadfile__drag-file-area {\r\n    display: none;\r\n}\r\n\r\n.uploadfile--added .uploadfile__fileName {\r\n    display: block;\r\n}\r\n\r\n.uploadfile__title {\r\n    padding-bottom: 8px;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n}\r\n\r\n.uploadfile__drag-file-area {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 96px;\r\n    background-color: #D0D0D0;\r\n    margin-bottom: 8px;\r\n    text-align: center;\r\n    border: 1px dashed #808080;\r\n    font-size: 9px;\r\n    font-weight: 400;\r\n    line-height: 16px;\r\n    color: #808080;\r\n    transition: border-color 0.3s, background-color 0.3s;\r\n}\r\n\r\n.uploadfile__info {\r\n    max-width: 95px;\r\n}\r\n\r\n.uploadfile__fileName {\r\n    display: none;\r\n    width: 100%;\r\n    margin-bottom: 9px;\r\n    padding-top: 4px;\r\n    padding-bottom: 4px;\r\n    text-align: center;\r\n    color: #000;\r\n    border: 1px solid #808080;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 16px;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n}\r\n\r\n.uploadfile__fileName--success {\r\n    background-color: #88CC99;\r\n}\r\n\r\n.uploadfile__fileName--error {\r\n    background-color: #EE6655;\r\n}\r\n\r\n.uploadfile__footer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n}\r\n\r\n.uploadfile__btn {\r\n    height: 18px;\r\n    padding-right: 8px;\r\n    padding-left: 8px;\r\n    font-weight: 400;\r\n    font-size: 9px;\r\n    line-height: 16px;\r\n    cursor: pointer;\r\n    border: 1px solid #808080;\r\n    background-color: transparent;\r\n}\r\n\r\n.uploadfile__btn--hidden {\r\n    display: none;\r\n}\r\n\r\n.uploadfile__btn:last-child {\r\n    margin-left: auto;\r\n}\r\n\r\n.uploadfile__upload-input {\r\n    display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
